export function shouldGenerateSizingAfterStructureSave(input: {
  savedSpaceCount: number;
  deletedSpaceCount: number;
  deletedLevelCount: number;
  levelTypeChangedCount?: number;
}): boolean {
  return (
    input.savedSpaceCount > 0 ||
    input.deletedSpaceCount > 0 ||
    input.deletedLevelCount > 0 ||
    (input.levelTypeChangedCount ?? 0) > 0
  );
}
